import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info-morbilidad',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgForOf
  ],
  templateUrl: './info-morbilidad.component.html',
  styleUrl: './info-morbilidad.component.css'
})
export class InfoMorbilidadComponent {


  listItems = [
    {
      texto: "Detecta problemas recurrentes de salud para evitar bajas laborales.",
    },
    {
      texto: "Un equipo saludable es más eficiente y comprometido con los objetivos de la empresa."
    },
    {
      texto: "Optimiza recursos con programas de salud ocupacional que generan un impacto tangible."
    },
    {
      texto: "Cumple con las regulaciones de seguridad y salud laboral, minimizando riesgos legales."
    }

  ]



}
